import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'
import { statusStr } from '@/constants/transactionStatus'
import DescriptionColumn from "../../gateway/components/statements-report-details-column";

const detailsTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'trace',
        title: i18n.t('statements-report.trace'),
        sortable: false,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'rrn',
        title: i18n.t('statements-report.rrn'),
        sortable: false,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'shamsi_date',
        title: i18n.t('transactions-report.transactionDate'),
        sortable: true,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'amount_double',
        title: i18n.t('transactions-report.price'),
        sortable: true,
        textAlign: 'center',
        width: 90
    },
    {
        field: 'status',
        sortable: true,
        title: i18n.t('transactions-report.status'),
        textAlign: 'center',
        template: (row) => {
            let variant
            let status_str
            if (row.status === "موفق") {
                variant = 'badge-success'
                status_str = statusStr.SUCCEED
            } else if (row.status === "ناموفق") {
                variant = 'badge-danger'
                status_str = statusStr.FAILED
            }
            else {
                variant = 'badge-warning'
                status_str = statusStr.REVERSED
            }

            return '<div class="badge '+variant+' text-white">'+ status_str+'</div>'
        },
        width: 80
    },
    {
        field: 'transactionDetails',
        sortable: false,
        title: i18n.t('label.description'),
        width: 80,
        textAlign: 'center',
        template: (row, index, datatable) => {
            return detailsTemplate(row, index, datatable)
        },
    },
]